import * as actionTypes from './actionTypes';
import axios from 'axios';
import axiosOrder from '../../axios-orders';

const authStart = () => {
  return {
    type: actionTypes.AUTH_START
  }
}

const authSuccess = (token, userId, email) => {
  localStorage.setItem('userData', JSON.stringify({ token: token, email: email, userId: userId }))
  return {
    type: actionTypes.AUTH_SUCCESS,
    token: token,
    userId: userId,
    email: email
  }
}

const authFailed = (error) => {
  return {
    type: actionTypes.AUTH_FAILED,
    error: error
  }
}

export const clearAuthError = () => {
  return {
    type: actionTypes.CLEAR_AUTH_ERROR
  }
}

export const setUserData = (token, userId, email) => {
  return {
    type: actionTypes.SET_USER_DATA,
    token: token,
    userId: userId,
    email: email

  }
}

export const checkAuthTimeout = () => {
  const expirationDate = new Date(localStorage.getItem('expirationDate')).getTime();
  const timeLeft = expirationDate - new Date().getTime();
  console.log(`Logout in ${Math.ceil(timeLeft / 1000)} seconds`)
  return dispatch => {
    const logoutTimeoutId = setTimeout(() => {
      dispatch(logout());
    }, timeLeft)
    dispatch(logoutTimeoutSet(logoutTimeoutId))
  }
}

const logoutTimeoutSet = (logoutTimeoutId) => {
  return {
    type: actionTypes.LOGOUT_TIMEOUT_SET,
    logoutTimeoutId: logoutTimeoutId
  }
}

export const logout = () => {
  localStorage.removeItem('userData');
  localStorage.removeItem('expirationDate');
  return dispatch => {
    dispatch({ type: actionTypes.LOGOUT });
    dispatch({ type: actionTypes.GET_ORDERS, orders: null });
    dispatch({ type: actionTypes.SET_NEXT_ID, nextID: null });
    dispatch({ type: actionTypes.SET_BURGER_DATA });
  }
}

export const setLoginRedirect = (redirectLocation) => {
  return {
    type: actionTypes.SET_LOGIN_REDIRECT,
    redirectLocation: redirectLocation
  }
}

export const authenticate = (email, password, type) => {
  return (dispatch) => {
    dispatch(authStart());
    const authData = {
      email: email,
      password: password,
      returnSecureToken: true
    }
    let userId = null;
    let token = null;
    let url = 'https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyCJz98ds4qYLbwnfwVZKKq7fxL0HVoDods'
    if (type === 'login') {
      url = 'https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyCJz98ds4qYLbwnfwVZKKq7fxL0HVoDods'
    }
    axios.post(url, authData)
      .then((response) => {
        const expirationDate = new Date(new Date().getTime() + ((response.data.expiresIn) * 1000));
        localStorage.setItem('expirationDate', expirationDate);
        dispatch(authSuccess(response.data.idToken, response.data.localId, response.data.email))
        dispatch(checkAuthTimeout())
        console.log(type);
        userId = response.data.localId;
        token = response.data.idToken;
      })
      .then(() => {
        console.log(userId);
        console.log(email);
        if (type !== 'login') {
          axiosOrder.patch(`/users/${userId}.json?auth=${token}`, { userInfo: { email: email } })
        }
      })
      .catch((error) => {
        if (error.response) {
          dispatch(authFailed(error.response.data.error.message))
        } else {
          dispatch(authFailed(error.message));
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/authActions.jsx